// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select2-container[data-v-5cfa4e58]{width:500px!important}", ""]);
// Exports
module.exports = exports;
